<template>
    <v-container fluid class="homepage-bg d-flex justify-center align-center pa-0"
        style="min-height: 90vh; padding: 0 !important;">
        <v-card max-width="90%" class="pa-7 text-center rounded-2xl elevation-3 homepage-card">
            <img src="/img/logo.png" alt="Logo" class="mb-3" style="width:60px; height:auto; object-fit:contain;" />

            <div class="mb-6" style="color:#5b6470;font-size:1.1rem;">
                {{ $t('title.izvjestaji') }}
            </div>

            <!-- RED 1 — 3 kartice -->
            <v-row class="ma-0 pa-0" justify="center">
                <v-col cols="12" sm="4" v-for="card in cardsRow1" :key="card.key" class="d-flex justify-center">
                    <v-card class="hoverable-card card-fit" outlined @click="openReport(card)"
                        style="overflow: hidden;">
                        <img :src="cardImages[card.key]" class="card-img" />
                    </v-card>
                </v-col>
            </v-row>

            <!-- RED 2 — 3 kartice -->
            <v-row class="ma-0 pa-0" justify="center">
                <v-col cols="12" sm="4" v-for="card in cardsRow2" :key="card.key" class="d-flex justify-center">
                    <v-card class="hoverable-card card-fit" outlined @click="openReport(card)"
                        style="overflow: hidden;">
                        <img :src="cardImages[card.key]" class="card-img" />
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </v-container>

    <!-- Amortizacija po unosu željenog datuma -->
    <BaseModal v-model="amortizationDialog" :title="$t('modalni.izvjestaji.amortizacija')">
        <v-form>
            <v-text-field v-model="amortizationDate" type="date" :label="$t('modalni.izvjestaji.izvjestajNaDan')"
                class="my-text" />
        </v-form>
        <template #footer>
            <v-btn variant="outlined" @click="amortizationDialog = false">
                {{ $t('general.cancel') }}
            </v-btn>
            <v-btn color="primary" :disabled="!amortizationDate" @click="downloadAmortizationPdf">
                {{ $t('general.view') }}
            </v-btn>
        </template>
    </BaseModal>

    <!-- KORISNIK PO ZADUZENJU -->
    <BaseModal v-model="userReportDialog" :title="$t('modalni.izvjestaji.korisnikPoZaduzenju')">
        <v-form ref="userReportForm" v-model="isUserFormValid">
            <v-select v-model="reportForm.userId" :items="usersWithAssignments" item-title="Name" item-value="UserId"
                :label="$t('table.controlPanel.zaposlenik')" :rules="[rules.required]" class="my-selectModal"
                clearable />
            <v-checkbox v-model="reportForm.includeDate" :label="$t('modalni.izvjestaji.izvjestajNaDan')"
                density="compact" hide-details class="mt-2 cb-text" />
            <v-expand-transition>
                <div v-if="reportForm.includeDate" class="mt-3">
                    <v-divider class="mb-3" />
                    <v-text-field v-model="reportForm.reportDate" type="date" :label="$t('general.date')"
                        class="my-text" :rules="[rules.required]" />
                </div>
            </v-expand-transition>
        </v-form>
        <template #footer>
            <div class="d-flex justify-end ga-2">
                <v-btn variant="outlined" @click="closeUserReportDialog">
                    <span style="font-size:14px; font-weight: 600;">{{ $t('general.cancel') }}</span>
                </v-btn>
                <v-btn color="primary" variant="flat" :disabled="disabledButton" @click="downloadUserPdf">
                    <span style="font-size:14px; font-weight:600">{{ $t('general.view') }}</span>
                </v-btn>
            </div>
        </template>
    </BaseModal>

    <!-- PREGLED STANJA SREDSTAVA -->
    <BaseModal v-model="statusDialog" :title="$t('modalni.izvjestaji.pregledStanjaStalnihSredstava')">
        <v-form ref="statusReportForm" v-model="isStatusFormValid">
            <v-text-field v-model="statusForm.reportDate" type="date" :label="$t('modalni.izvjestaji.izvjestajNaDan')"
                :rules="[rules.required]" class="my-text" required />
            <div class="text-subtitle-2 font-weight-medium mt-3 d-flex align-center" style="cursor:pointer;"
                @click="showFilters = !showFilters">
                {{ $t('general.filteri') }}
                <v-icon size="16"
                    :style="{ transform: showFilters ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }">
                    mdi-chevron-down
                </v-icon>
            </div>
            <v-expand-transition>
                <div v-if="showFilters" class="mt-3">
                    <v-divider class="mb-3" />
                    <v-select v-model="filters.userId" :items="inventoryEmployees" item-title="Name" item-value="UserId"
                        :label="$t('table.controlPanel.zaposlenik')" class="my-selectModal" clearable />
                    <v-select v-model="filters.category" :items="inventoryCategories"
                        :label="$t('table.asset.kategorija')" class="my-selectModal" clearable />
                    <v-select v-model="filters.location" :items="inventoryLocations" item-title="Name" item-value="Id"
                        :label="$t('table.assetFull.Lokacija')" class="my-selectModal" clearable
                        @update:model-value="onReportLocationChange" />
                    <v-select v-model="filters.room" :items="inventoryRooms" item-title="name" item-value="id"
                        :label="$t('table.asset.soba')" class="my-selectModal" clearable
                        :disabled="!filters.location || !inventoryRooms.length" />
                </div>
            </v-expand-transition>
        </v-form>
        <template #footer>
            <div class="d-flex justify-end ga-2">
                <v-btn variant="outlined" @click="closeStatusDialog">
                    <span style="font-size:14px; font-weight: 600;">{{ $t('general.cancel') }}</span>
                </v-btn>
                <v-btn color="primary" variant="flat" :disabled="!statusForm.reportDate" @click="downloadStatusPdf">
                    <span style="font-size:14px; font-weight:600">{{ $t('general.view') }}</span>
                </v-btn>
            </div>
        </template>
    </BaseModal>

    <!-- POPISNA LISTA STALNA SREDSTVA -->
    <BaseModal v-model="inventoryDialog" :title="$t('modalni.izvjestaji.reportStalnaSredstva')">
        <v-form ref="inventoryReportForm" v-model="isInventoryFormValid">
            <v-text-field v-model="inventoryForm.reportDate" type="date"
                :label="$t('modalni.izvjestaji.izvjestajNaDan')" :rules="[rules.required]" class="my-text" required />
            <div class="text-subtitle-2 font-weight-medium mt-3 d-flex align-center" style="cursor:pointer;"
                @click="showFilters = !showFilters">
                {{ $t('general.filteri') }}
                <v-icon size="16"
                    :style="{ transform: showFilters ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }">
                    mdi-chevron-down
                </v-icon>
            </div>
            <v-expand-transition>
                <div v-if="showFilters" class="mt-3">
                    <v-divider class="mb-3" />
                    <v-select v-model="filters.userId" :items="inventoryEmployees" item-title="Name" item-value="UserId"
                        :label="$t('table.controlPanel.zaposlenik')" class="my-selectModal" clearable />
                    <v-select v-model="filters.category" :items="inventoryCategories"
                        :label="$t('table.asset.kategorija')" class="my-selectModal" clearable />
                    <v-select v-model="filters.location" :items="inventoryLocations" item-title="Name" item-value="Id"
                        :label="$t('table.assetFull.Lokacija')" class="my-selectModal" clearable
                        @update:model-value="onReportLocationChange" />
                    <v-select v-model="filters.room" :items="inventoryRooms" item-title="name" item-value="id"
                        :label="$t('table.asset.soba')" class="my-selectModal" clearable
                        :disabled="!filters.location || !inventoryRooms.length" />
                </div>
            </v-expand-transition>
        </v-form>
        <template #footer>
            <div class="d-flex justify-end ga-2">
                <v-btn variant="outlined" @click="closeInventoryDialog">
                    <span style="font-size:14px; font-weight:600">{{ $t('general.cancel') }}</span>
                </v-btn>
                <v-btn color="primary" variant="flat" :disabled="!inventoryForm.reportDate"
                    @click="downloadInventoryPdf">
                    <span style="font-size:14px; font-weight:600">{{ $t('general.view') }}</span>
                </v-btn>
            </div>
        </template>
    </BaseModal>

    <!-- POPISNA LISTA SITNI INVENTAR -->
    <BaseModal v-model="smallInventoryDialog" :title="$t('modalni.izvjestaji.reportSitniInventar')">
        <v-form ref="smallInventoryReportForm" v-model="isSmallInventoryFormValid">
            <v-text-field v-model="smallInventoryForm.reportDate" type="date"
                :label="$t('modalni.izvjestaji.izvjestajNaDan')" :rules="[rules.required]" class="my-text" required />
            <div class="text-subtitle-2 font-weight-medium mt-3 d-flex align-center" style="cursor:pointer;"
                @click="showFilters = !showFilters">
                {{ $t('general.filteri') }}
                <v-icon size="16"
                    :style="{ transform: showFilters ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }">
                    mdi-chevron-down
                </v-icon>
            </div>
            <v-expand-transition>
                <div v-if="showFilters" class="mt-3">
                    <v-divider class="mb-3" />
                    <v-select v-model="filters.userId" :items="smallInventoryEmployees" item-title="Name"
                        item-value="Id" :label="$t('table.controlPanel.zaposlenik')" class="my-selectModal" clearable />
                    <v-select v-model="filters.location" :items="smallInventoryLocations" item-title="Name"
                        item-value="Id" :label="$t('table.assetFull.Lokacija')" class="my-selectModal" clearable
                        @update:model-value="onReportLocationChange" />
                    <v-select v-model="filters.room" :items="smallInventoryRooms" item-title="name" item-value="id"
                        :label="$t('table.asset.soba')" class="my-selectModal" clearable
                        :disabled="!filters.location || !smallInventoryRooms.length" />
                </div>
            </v-expand-transition>
        </v-form>
        <template #footer>
            <div class="d-flex justify-end ga-2">
                <v-btn variant="outlined" @click="closeSmallInventoryDialog">
                    <span style="font-size:14px; font-weight:600">{{ $t('general.cancel') }}</span>
                </v-btn>
                <v-btn color="primary" variant="flat" :disabled="!smallInventoryForm.reportDate"
                    @click="downloadSmallInventoryPdf">
                    <span style="font-size:14px; font-weight:600">{{ $t('general.view') }}</span>
                </v-btn>
            </div>
        </template>
    </BaseModal>

    <!-- ISTORIJA ZADUZENJA -->
    <BaseModal v-model="historyDialog" size="lg" :title="$t('modalni.izvjestaji.istorijaZaduzenjaStalnogSredstva')">
        <v-form ref="historyReportForm" v-model="isHistoryFormValid">
            <v-select v-model="historyForm.assetId" :items="assets"
                :item-title="a => `${a.Name},  ${$t('table.asset.InvBr')}: ${a.InvNumber}`" item-value="Id"
                :label="$t('table.asset.sredstvo')" :rules="[rules.required]" class="my-selectModal"
                density="comfortable" required />
        </v-form>
        <template #footer>
            <div class="d-flex justify-end ga-2">
                <v-btn variant="outlined" @click="closeHistoryDialog">
                    <span style="font-size:14px; font-weight:600">{{ $t('general.cancel') }}</span>
                </v-btn>
                <v-btn color="primary" variant="flat" :disabled="!historyForm.assetId" @click="printHistory">
                    <span style="font-size:14px; font-weight:600">{{ $t('general.view') }}</span>
                </v-btn>
            </div>
        </template>
    </BaseModal>

    <!-- PRINT PREVIEW -->
    <BaseModal v-model="reportPreview" size="xl" :title="reportTitle" height="90vh" modalClass="report-modal"
        :hideFooter="true">
        <template #header-actions>
            <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.download')">
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon variant="plain" @click="downloadPDF">
                        <v-icon size="18"
                            style="padding-top: 2px !important; padding-left: 10px !important;">mdi-download</v-icon>
                    </v-btn>
                </template>
            </v-tooltip>
            <v-tooltip v-if="!isOdlukaPreview" location="bottom" content-class="custom-tooltip"
                :text="$t('general.print')">
                <template #activator="{ props }">
                    <v-btn v-bind="props" icon variant="plain" @click="printReport">
                        <v-icon size="18">mdi-printer</v-icon>
                    </v-btn>
                </template>
            </v-tooltip>
        </template>
        <iframe ref="reportFrame" :style="{
            width: '100%', height: '100%', border: 'none',
            transform: `scale(${zoom})`, transformOrigin: 'top left'
        }" />
    </BaseModal>

</template>

<script>
import { printTable, fetchHeaderImage } from "@/services/printService";
import BaseModal from "@/components/dialogs/BaseModal.vue";
import html2pdf from "html2pdf.js"
import { format } from "date-fns";

export default {
    name: "ReportsPage",
    components: { BaseModal },
    data() {
        return {
            isOdlukaPreview: false,
            komisija: null,
            amortizationDialog: false,
            amortizationDate: null,
            reportTitle: '',
            isUserFormValid: false,
            isStatusFormValid: false,
            isInventoryFormValid: false,
            isSmallInventoryFormValid: false,
            isHistoryFormValid: false,
            locations: [],
            rooms: [],
            showFilters: false,
            filters: { userId: null, category: null, location: null, room: null },
            assets: [],
            loadingAssets: false,
            inventoryDialog: false,
            inventoryForm: { reportDate: null },
            smallInventoryDialog: false,
            smallInventoryForm: { reportDate: null },
            smallAssets: [],
            statusDialog: false,
            statusForm: { reportDate: null },
            historyDialog: false,
            historyForm: { assetId: null, from: null, to: null, allAssets: false },
            historyData: [],
            userReportDialog: false,
            reportForm: {
                userId: null,
                includeCommission: false,
                includeDate: false,
                reportDate: null,
                disabledButton: true
            },
            employees: [],
            rules: {
                required: v => (v !== null && v !== undefined && v !== '') || this.$t('systemMessage.m1'),
            },
            reportPreview: false,
            zoom: 1,
            html: '',

            // KARTICE — RED 1
            cardsRow1: [
                { key: 'izvjestaj1', title: 'izvjestaji.1' },
                { key: 'izvjestaj2', title: 'izvjestaji.2' },
                { key: 'izvjestaj3', title: 'izvjestaji.3' },
            ],
            // KARTICE — RED 2
            cardsRow2: [
                { key: 'izvjestaj4', title: 'izvjestaji.4' },
                { key: 'izvjestaj5', title: 'izvjestaji.5' },
                { key: 'izvjestaj6', title: 'izvjestaji.6' },
            ],
            // KARTICE — RED 3 (2 kartice)
            cardsRow3: [
                { key: 'izvjestaj7', title: 'izvjestaji.7' },
                { key: 'izvjestaj8', title: 'izvjestaji.8' },
            ],
        };
    },
    computed: {
        currentLang() {
            const lang = localStorage.getItem('lang')
            if (lang === 'sr' || lang === 'cir-ekavica') return '_cir'
            if (lang === 'en') return '_eng'
            return ''
        },
        cardImages() {
            const lang = this.currentLang
            return {
                izvjestaj1: `/img/Report1${lang}.png`,
                izvjestaj2: `/img/Report2${lang}.png`,
                izvjestaj3: `/img/Report3${lang}.png`,
                izvjestaj4: `/img/Report4${lang}.png`,
                izvjestaj5: `/img/Report5${lang}.png`,
                izvjestaj6: `/img/Report6${lang}.png`,
                izvjestaj7: `/img/Report7${lang}.png`,
                izvjestaj8: `/img/Report8${lang}.png`,
            }
        },
        usersWithAssignments() {
            const ids = new Set()
            this.assets.forEach(a => { if (a.UserId) ids.add(Number(a.UserId)) })
            this.smallAssets.forEach(a => { if (a.UserId) ids.add(Number(a.UserId)) })
            return this.employees.filter(e => ids.has(Number(e.UserId)))
        },
        smallInventoryEmployees() {
            const ids = new Set(this.smallAssets.map(a => Number(a.UserId)).filter(Boolean))
            return this.employees.filter(e => ids.has(Number(e.UserId)))
        },
        smallInventoryLocations() {
            const ids = new Set(this.smallAssets.map(a => Number(a.LocationId)).filter(Boolean))
            return this.locations.filter(l => ids.has(Number(l.Id)))
        },
        smallInventoryRooms() {
            if (!this.filters.location) return []
            const roomNames = new Set(
                this.smallAssets
                    .filter(a => Number(a.LocationId) === Number(this.filters.location))
                    .map(a => a.RoomName).filter(Boolean)
            )
            return this.rooms.filter(r => roomNames.has(r.name))
        },
        inventoryCategories() {
            return [...new Set(this.assets.map(a => a.CategoryName).filter(Boolean))]
        },
        inventoryEmployees() {
            const ids = new Set(this.assets.map(a => Number(a.UserId)).filter(Boolean))
            return this.employees.filter(e => ids.has(Number(e.UserId)))
        },
        inventoryLocations() {
            const ids = new Set(this.assets.map(a => Number(a.LocationId)).filter(Boolean))
            return this.locations.filter(l => ids.has(Number(l.Id)))
        },
        inventoryRooms() {
            if (!this.filters.location) return []
            const roomIds = new Set(
                this.assets
                    .filter(a => Number(a.LocationId) === Number(this.filters.location))
                    .map(a => a.RoomId).filter(Boolean)
            )
            return this.rooms.filter(r => roomIds.has(r.id))
        },
        disabledButton() {
            return (
                !this.reportForm.userId ||
                (this.reportForm.includeDate && !this.reportForm.reportDate)
            )
        }
    },
    methods: {

        async openReport(card) {
            const title = this.$t(card.title)

            if (title === this.$t('izvjestaji.1')) {
                this.amortizationDialog = true
                this.amortizationDate = new Date().toISOString().split('T')[0]
            }

            if (title === this.$t('izvjestaji.2')) {
                this.userReportDialog = true
                this.reportForm.reportDate = new Date().toISOString().split('T')[0]
                if (!this.employees.length)
                    await Promise.all([this.fetchEmployees(), this.fetchAssets(), this.fetchSmallInventory()])
                await this.fetchKomisija()
            }

            if (title === this.$t('izvjestaji.3')) {
                this.statusDialog = true
                this.statusForm.reportDate = new Date().toISOString().split('T')[0]
                if (!this.employees.length) await this.fetchEmployees()
                await this.fetchAssets()
                await this.fetchLocations()
            }

            if (title === this.$t('izvjestaji.4')) {
                this.inventoryDialog = true
                this.inventoryForm.reportDate = new Date().toISOString().split('T')[0]
                if (!this.employees.length) await this.fetchEmployees()
                await this.fetchAssets()
                await this.fetchLocations()
            }

            if (title === this.$t('izvjestaji.5')) {
                this.smallInventoryDialog = true
                this.smallInventoryForm.reportDate = new Date().toISOString().split('T')[0]
                if (!this.employees.length) await this.fetchEmployees()
                if (!this.smallAssets?.length) {
                    await this.fetchSmallInventory()
                    await this.fetchLocations()
                }
            }

            if (title === this.$t('izvjestaji.6')) {
                this.historyDialog = true
                await this.fetchAssets()
            }
        },

        generateReportFileName(title) {
            const date = new Date()
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            const formattedDate = `${day}${month}${year}`
            const cleanTitle = title
                .replaceAll(" ", "_").replaceAll("č", "c").replaceAll("ć", "c")
                .replaceAll("ž", "z").replaceAll("š", "s").replaceAll("đ", "d")
            return `${cleanTitle}_${formattedDate}.pdf`
        },

        openReportPreview(html, title) {
            this.reportTitle = title
            this.reportPreview = true
            this.$nextTick(() => {
                const iframe = this.$refs.reportFrame
                const doc = iframe.contentWindow.document
                doc.open()
                doc.write(html)
                doc.close()
            })
        },

        printReport() {
            this.$refs.reportFrame.contentWindow.print()
        },

        downloadPDF() {
            if (this._odlukaBlob) {
                const url = URL.createObjectURL(this._odlukaBlob)
                const link = document.createElement('a')
                link.href = url
                link.download = this._odlukaFileName
                document.body.appendChild(link)
                link.click()
                link.remove()
                URL.revokeObjectURL(url)
                this._odlukaBlob = null
                this._odlukaFileName = null
                return
            }
            const container = document.createElement("div")
            container.innerHTML = this.html
            const title = container.querySelector("h2")?.innerText
            const fileName = this.generateReportFileName(title)
            html2pdf().set({
                margin: 10, filename: fileName,
                html2canvas: { scale: 2 },
                jsPDF: { unit: "mm", format: "a4", orientation: "landscape" }
            }).from(container).save()
        },

        async fetchKomisija() {
            try {
                const r = await this.$axios.post('Komisije/ShowActive', {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                })
                this.komisija = Array.isArray(r.data) ? r.data[0] : r.data
            } catch (err) {
                console.error(this.$t('general.noData'), err)
                this.komisija = null
            }
        },

        async fetchHistory() {
            const payload = {
                CompanyId: Number(localStorage.getItem("CompanyId")),
                AssetId: this.historyForm.assetId,
                LanguageId: Number(localStorage.getItem('LanguageId'))
            }
            const r = await this.$axios.post("Asset/StalnaSredstva_Istorijat_Zaduzenje", payload)
            this.historyData = r.data
        },

        async printHistory() {
            const headerImg = await fetchHeaderImage(this.$axios)
            if (!this.historyForm.assetId) return
            await this.fetchHistory()
            if (!this.historyData.length) {
                this.$store.dispatch("NOTIF_WARNING", { poruka: this.$t("general.noData"), timer: 2500, position: "top-end" })
                return
            }

            const tbodyHtml = this.historyData.map((h, i) => `
<tr>
<td class="left">${i + 1}</td>
<td class="left">${h.AssetName || ""}</td>
<td class="left">${h.InvNumber || ""}</td>
<td class="left">${i === 0 ? "" : (this.historyData[i - 1].Name || this.$t('general.nerasporedjeno'))}</td>
<td class="left">${h.Name || this.$t('general.nerasporedjeno')}</td>
<td class="left">${h.Date || ""}</td>
</tr>`).join("")
            const theadHtml = `
<tr>
<th style="width:6%">${this.$t("table.asset.rbr")}</th>
<th style="width:26%">${this.$t("table.asset.naziv")}</th>
<th style="width:8%">${this.$t("table.asset.InvBr")}</th>
<th style="width:22%">${this.$t("modalni.izvjestaji.prethodnoZaduzenje")}</th>
<th style="width:22%">${this.$t("modalni.izvjestaji.novoZaduzenje")}</th>
<th style="width:16%">${this.$t("modalni.izvjestaji.datumIzmjene")}</th>
</tr>`
            const extraCss = `@page{size:A4 landscape;margin:12mm;}.left{text-align:left !important;}.center{text-align:center !important;}.right{text-align:right !important;}table{margin-top:40px;}.right{white-space:nowrap;}th{text-align:left !important;}td{text-align:left !important;}`
            this.html = printTable({
                title: `${this.$t("modalni.izvjestaji.istorijaZaduzenjaStalnogSredstva")}`,
                theadHtml, tbodyHtml, extraCss, headerImg,
                footer: `${this.$t("exportToExcel.pokrenuo")} ${localStorage.getItem("Name")} <br/>${this.$t("print.m1")} ${format(new Date(), "dd.MM.yyyy.")}`
            })
            this.openReportPreview(this.html, this.$t("modalni.izvjestaji.istorijaZaduzenjaStalnogSredstva"))
            this.closeHistoryDialog()
        },

        closeUserReportDialog() {
            this.userReportDialog = false
            this.reportForm = { userId: null, includeCommission: false, includeDate: false, reportDate: null, disabledButton: true }
            this.$nextTick(() => { this.$refs.userReportForm?.resetValidation() })
        },
        closeStatusDialog() {
            this.statusDialog = false
            this.$nextTick(() => { this.$refs.statusReportForm?.resetValidation() })
        },
        closeInventoryDialog() {
            this.inventoryDialog = false
            this.$nextTick(() => { this.$refs.inventoryReportForm?.resetValidation() })
        },
        closeSmallInventoryDialog() {
            this.smallInventoryDialog = false
            this.$nextTick(() => { this.$refs.smallInventoryReportForm?.resetValidation() })
        },
        closeHistoryDialog() {
            this.historyDialog = false
            this.historyForm = {
                assetId: null
            }
            this.$nextTick(() => { this.$refs.historyReportForm?.resetValidation() })
        },

        async onReportLocationChange(locationId) {
            this.filters.room = null
            this.rooms = []
            if (!locationId) return
            try {
                const res = await this.$axios.post('Location/Rooms', {
                    LocationId: Number(locationId),
                    CompanyId: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                })
                this.rooms = (Array.isArray(res.data) ? res.data : [])
                    .map(r => ({ id: r.Id, name: r.Name }))
                    .sort((a, b) => a.name.localeCompare(b.name, "sr-Latn", { sensitivity: "base", ignorePunctuation: true }))
            } catch (err) {
                console.error(this.$t('User_message.m106'), err)
                this.rooms = []
            }
        },

        async fetchLocations() {
            try {
                const r = await this.$axios.post('Location/Locations/', {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                })
                this.locations = r.data
            } catch (err) {
                console.error(this.$t('general.noData'), err)
                this.locations = []
            }
        },

        resetFilters() {
            this.showFilters = false
            this.filters = { userId: null, category: null, location: null, room: null }
        },

        formatMoney(v) {
            return Number(v || 0).toLocaleString("sr-Latn-BA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },

        async fetchAssets() {
            try {
                const r = await this.$axios.post('Asset/StalnaSredstva/', {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                })
                this.assets = r.data
            } catch (err) {
                console.error(this.$t('general.noData'), err)
                this.assets = []
            }
        },

        formatDate(d) {
            if (!d) return ""
            return new Date(d).toLocaleDateString("sr-Latn-BA", { day: '2-digit', month: '2-digit', year: 'numeric' })
        },

        async fetchEmployees() {
            try {
                const r = await this.$axios.post('User/Show/', {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                })
                this.employees = r.data || []
            } catch (err) {
                console.error(this.$t('general.noData'), err)
                this.employees = []
            }
        },

        async fetchSmallInventory() {
            try {
                const res = await this.$axios.post('SmallAsset/SitnaSredstva/', {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                })
                this.smallAssets = res.data || []
            } catch (err) {
                console.error(this.$t('general.noData'), err)
                this.smallAssets = []
            }
        },

        async downloadAmortizationPdf() {
            const payload = {
                Id: Number(localStorage.getItem("CompanyId")),
                LanguageId: Number(localStorage.getItem("LanguageId")),
                Date: this.amortizationDate,
                StatusIds: [1, 2, 4]
            }
            const r = await this.$axios.post("Asset/ShowAssetPerKonto_Kumulativno", payload)
            const data = r.data || []
            if (!data.length) {
                this.$store.dispatch("NOTIF_WARNING", { poruka: this.$t("general.noData"), position: "top-end", timer: 2500 })
                return
            }
            const headerImg = await fetchHeaderImage(this.$axios)
            let tbodyHtml = ""
            data.forEach(row => {
                tbodyHtml += `
<tr>
<td class="left">${row.Category}</td>
<td class="right">${this.formatMoney(row.PurchaseValue)}</td>
<td class="right">${this.formatMoney(row.ValuePrevYear)}</td>
<td class="right">${this.formatMoney(row.DepreciationYear)}</td>
<td class="right">${this.formatMoney(row.TotalDepreciation)}</td>
<td class="right">${this.formatMoney(row.CurrentValue)}</td>
</tr>`
            })
            const theadHtml = `
<tr>
<th style="width:28%">${this.$t("modalni.izvjestaji.kategorija") || 'Kategorija'}</th>
<th style="width:14.4%;">${this.$t("modalni.izvjestaji.nabVrijednost")}</th>
<th style="width:14.4%;">${this.$t("modalni.izvjestaji.vrijednostNaDan")}</th>
<th style="width:14.4%;">${this.$t("modalni.izvjestaji.ispravkaZaGodinu")}</th>
<th style="width:14.4%;">${this.$t("modalni.izvjestaji.ukupnaIspravka")}</th>
<th style="width:14.4%;">${this.$t("modalni.izvjestaji.trenutnaVrijednost")}</th>
</tr>`
            const extraCss = `
@page { size: A4 landscape; margin: 12mm; }
.left { text-align: left !important; }
.right { text-align: right !important; white-space: nowrap; }
table { margin-top: 40px; }
td:first-child { text-align: left !important; }
td:not(:first-child) { text-align: right !important; }
th { text-align: left !important; }
`
            this.html = printTable({
                title: `${this.$t("modalni.izvjestaji.amortizacija")} ${this.formatDate(this.amortizationDate)}`,
                theadHtml, tbodyHtml, extraCss,
                headerImg,

                footer: `${this.$t("exportToExcel.pokrenuo")} ${localStorage.getItem("Name")} <br/>${this.$t("print.m1")} ${format(new Date(), "dd.MM.yyyy.")}`
            })
            this.openReportPreview(this.html, this.$t("modalni.izvjestaji.amortizacija"))
            this.amortizationDialog = false
            this.resetFilters()
        },

        async downloadUserPdf() {
            const headerImg = await fetchHeaderImage(this.$axios)
            const userId = this.reportForm.userId
            const reportDate = this.reportForm.reportDate
            if (!userId) return
            const combined = [
                ...this.assets.map(a => ({ ...a, __type: "asset" })),
                ...this.smallAssets.map(a => ({ ...a, __type: "small" }))
            ]
            let filtered = combined.filter(a => Number(a.UserId) === Number(userId))
            if (this.reportForm.includeDate && reportDate) {
                filtered = filtered.filter(a => a.__type === "small" || (a.Date && a.Date <= reportDate))
            }
            if (!filtered.length) {
                this.$store.dispatch("NOTIF_WARNING", { poruka: this.$t("general.noData"), position: "top-end", timer: 2500 })
                return
            }
            const employee = this.employees.find(e => Number(e.UserId) === Number(userId))?.Name || ""
            const titleDate = this.reportForm.includeDate && reportDate ? " - " + this.formatDate(reportDate) : ""
            const sviClanovi = this.komisija?.Members ? this.komisija.Members.split('\n').map(m => m.trim()).filter(Boolean) : []
            const predsjednik = sviClanovi[0] || ''
            const clanovi = sviClanovi.slice(1)
            const clanoviHtml = clanovi.map(ime => `
<div style="display:flex; justify-content:flex-end; margin-top:40px;">
<div style="text-align:right; min-width:250px;">
<div style="width:250px; border-top:1px solid #000;"></div>
<div style="margin-top:10px;">${ime}</div>
<div style="font-size:14px; color:#555; margin-top:10px;">${this.$t('table.komisije.clan')}</div>
</div></div>`).join('')
            this.html = printTable({
                title: `${this.$t("modalni.izvjestaji.korisnikPoZaduzenju")}${titleDate}`,
                columns: [
                    { key: "rb", label: this.$t("table.asset.rbr"), width: "7%" },
                    { key: "type", label: this.$t("general.tip"), width: "15%" },
                    { key: "asset", label: this.$t("table.asset.naziv"), width: "34%" },
                    { key: "inv", label: this.$t("table.asset.InvBr"), width: "10%" },
                    { key: "serial", label: this.$t("table.asset.sn"), width: "10%" },
                    { key: "room", label: this.$t("table.asset.soba"), width: "14%" },
                    { key: "location", label: this.$t("table.assetFull.Lokacija"), width: "10%" }
                ],
                data: filtered.map((a, i) => ({
                    type: a.__type === "asset" ? this.$t("general.stalnoSredstvo") : this.$t("general.sitniInventar"),
                    rb: i + 1, asset: a.Name ?? "",
                    inv: a.__type === "asset" ? (a.InvNumber ?? "") : "-",
                    serial: a.__type === "asset" ? (a.SerialNumber ?? "") : "-",
                    room: a.RoomName ?? "", location: a.LocationName ?? ""
                })),
                headerImg,
                footer: `
<div style="margin-top:40px; display:flex; justify-content:space-between; align-items:flex-start;">
<div>${this.$t("izvjestaji.datum")}: ${this.formatDate(new Date())}</div>
<div style="text-align:right;">
<strong>${this.$t("modalni.izvjestaji.zaduzenaOsoba")}</strong><br/><br/>
<div>${employee}</div>
<div style="margin-top:40px; width:250px; border-top:1px solid #000; margin-left:auto;"></div>
</div></div>
<div style="margin-top:50px; border-top:1px solid #ddd; padding-top:20px; text-align:right;">
<strong>${this.$t("table.komisije.naslov")}</strong>
<div style="display:flex; justify-content:flex-end; margin-top:40px;">
<div style="text-align:right; min-width:250px;">
<div style="width:250px; border-top:1px solid #000;"></div>
<div style="margin-top:10px;">${predsjednik}</div>
<div style="font-size:14px; color:#555; margin-top:10px;">${this.$t('table.komisije.predsjednik')}</div>
</div></div>${clanoviHtml}</div>`
            })
            this.openReportPreview(this.html, this.$t("modalni.izvjestaji.korisnikPoZaduzenju"))
            this.closeUserReportDialog()
            this.resetFilters()
        },

        async downloadStatusPdf() {
            const headerImg = await fetchHeaderImage(this.$axios)
            if (!this.statusForm.reportDate) return
            const selected = new Date(this.statusForm.reportDate)
            selected.setHours(0, 0, 0, 0)
            let filteredAssets = this.assets.filter(a => {
                if (!a.Date) return true
                const assetDate = new Date(a.Date)
                assetDate.setHours(0, 0, 0, 0)
                return assetDate.getTime() <= selected.getTime()
            })
            if (this.filters.userId) filteredAssets = filteredAssets.filter(a => a.UserId == this.filters.userId)
            if (this.filters.category) filteredAssets = filteredAssets.filter(a => a.CategoryName == this.filters.category)
            if (this.filters.location) filteredAssets = filteredAssets.filter(a => Number(a.LocationId) === Number(this.filters.location))
            if (this.filters.room) filteredAssets = filteredAssets.filter(a => a.RoomName == this.filters.room)
            if (!filteredAssets.length) {
                this.$store.dispatch("NOTIF_WARNING", { poruka: this.$t("general.noData"), timer: 2500, position: "top-end" })
                return
            }
            filteredAssets = filteredAssets.filter(a => a.CategoryName)
            const groups = {}
            filteredAssets.forEach(a => {
                const cat = a.CategoryName
                if (!groups[cat]) groups[cat] = []
                groups[cat].push(a)
            })
            let tbodyHtml = ""
            Object.keys(groups)
                .sort((a, b) => a.localeCompare(b, "sr-Latn", { sensitivity: "base", ignorePunctuation: true }))
                .forEach(cat => {
                    tbodyHtml += `<tr class="cat-row"><td colspan="10">${cat}</td></tr>`
                    let total = 0
                    groups[cat].forEach(a => {
                        const qty = Number(a.Quantity)
                        const price = Number(a.Price || 0)
                        total += price
                        tbodyHtml += `<tr>
<td class="left">${a.Name || ""}</td><td class="center">${a.InvNumber || ""}</td>
<td class="center">${qty}</td><td class="right">${this.formatMoney(price)}</td>
<td class="center">${qty}</td><td class="right">${this.formatMoney(price)}</td>
<td class="center">0</td><td class="right">0,00</td>
<td class="left">${a.UName || ""}</td><td class="left">${a.LocationName || ""}</td>
</tr>`
                    })
                    tbodyHtml += `<tr class="total-row">
<td colspan="3" class="left">${this.$t("modalni.izvjestaji.ukupnoZaKategoriju")}${cat}</td>
<td class="right">${this.formatMoney(total)}</td>
<td class="center"></td><td class="right">${this.formatMoney(total)}</td>
<td class="center"></td><td class="right">0,00</td>
<td colspan="2"></td></tr>
<tr class="spacer-row"><td colspan="10"></td></tr>`
                })
            const theadHtml = `
<tr>
<th rowspan="2" style="width:28%">${this.$t("table.asset.naziv")}</th>
<th rowspan="2" style="width:5%">${this.$t("table.asset.InvBr")}</th>
<th colspan="2" style="width:18%; text-align:center !important">${this.$t("modalni.izvjestaji.stanjePoPopisu")}</th>
<th colspan="2" style="width:18%; text-align:center !important">${this.$t("modalni.izvjestaji.stanjePoKnjigama")}</th>
<th colspan="2" style="width:18%; text-align:center !important">${this.$t("modalni.izvjestaji.razlika")}</th>
<th rowspan="2" style="width:10%">${this.$t("modalni.izvjestaji.zaduzenje")}</th>
<th rowspan="2" style="width:3%">${this.$t("modalni.izvjestaji.lokacija")}</th>
</tr>
<tr>
<th style="width:4%">${this.$t("general.kolicina")}</th>
<th style="width:11%">${this.$t("modalni.izvjestaji.nabVr")}</th>
<th style="width:4%">${this.$t("general.kolicina")}</th>
<th style="width:11%">${this.$t("modalni.izvjestaji.nabVr")}</th>
<th style="width:4%">${this.$t("general.kolicina")}</th>
<th style="width:11%">${this.$t("modalni.izvjestaji.nabVr")}</th>
</tr>`
            const extraCss = `@page{size:A4 landscape !important;margin:12mm !important;}.left{text-align:left !important;}.center{text-align:center !important;}.right{text-align:right !important;}.cat-row td{font-weight:700;border-top:2px !important;background:#fff;}.total-row td{font-weight:700;background:#fff;}.spacer-row td{border:none !important;height:10px;padding:0 !important;}.right{white-space:nowrap !important;}table{margin-top:40px !important;}th{text-align:center !important;}`
            this.html = printTable({
                title: `${this.$t("modalni.izvjestaji.pregledStanjaStalnihSredstava")} ${this.$t("general.naDan")} ${this.formatDate(selected)}`,
                theadHtml, tbodyHtml, extraCss, headerImg,
                footer: `${this.$t("exportToExcel.pokrenuo")} ${localStorage.getItem("Name")} <br />${this.$t("print.m1")} ${format(new Date(), "dd.MM.yyyy.")}`
            })
            this.openReportPreview(this.html, this.$t("modalni.izvjestaji.pregledStanjaStalnihSredstava"))
            this.closeStatusDialog()
            this.resetFilters()
        },

        async downloadInventoryPdf() {
            const headerImg = await fetchHeaderImage(this.$axios)
            let filtered = [...this.assets]
            if (this.filters.userId) filtered = filtered.filter(a => a.UserId == this.filters.userId)
            if (this.filters.category) filtered = filtered.filter(a => a.CategoryName == this.filters.category)
            if (this.filters.location) filtered = filtered.filter(a => Number(a.LocationId) === Number(this.filters.location))
            if (this.filters.room) filtered = filtered.filter(a => Number(a.RoomId) === Number(this.filters.room))
            if (!filtered.length) {
                this.$store.dispatch("NOTIF_WARNING", { poruka: this.$t("general.noData"), position: "top-end", timer: 2500 })
                return
            }
            const date = this.inventoryForm.reportDate
            if (!date) return
            let tbodyHtml = ""
            filtered.forEach((a, i) => {
                tbodyHtml += `<tr><td class="left">${i + 1}</td><td class="left">${a.Name ?? ""}</td><td class="left">${a.LocationName ?? ""}</td><td class="left">${a.RoomName ?? ""}</td><td class="left">1</td><td class="left"></td></tr>`
            })
            const theadHtml = `<tr><th style="width:6%">R.br</th><th style="width:28%">${this.$t("table.asset.naziv")}</th><th style="width:18%">${this.$t("modalni.izvjestaji.lokacija")}</th><th style="width:12%">${this.$t("table.asset.soba")}</th><th style="width:8%">${this.$t("general.kolicina")}</th><th style="width:28%; text-align:left !important">${this.$t("modalni.izvjestaji.napomena")}</th></tr>`
            const extraCss = `@page{size:A4 landscape !important;margin:12mm !important;}thead th{background-color:#AFB1B5 !important;color:#ffffff !important;font-weight:700 !important;border:1px solid #949597 !important;-webkit-print-color-adjust:exact;print-color-adjust:exact;}.left{text-align:left !important;}.center{text-align:center !important;}table{margin-top:40px !important;}th{text-align:left !important;}`

            this.html = printTable({
                title: `${this.$t("modalni.izvjestaji.popisnaListaStalnaSredstva")} ${this.formatDate(date)}`,
                theadHtml, tbodyHtml, extraCss, headerImg,
                footer: `${this.$t("exportToExcel.pokrenuo")} ${localStorage.getItem("Name")} <br />${this.$t("print.m1")} ${format(new Date(), "dd.MM.yyyy.")}`
            })
            this.openReportPreview(this.html, this.$t("modalni.izvjestaji.popisnaListaStalnaSredstva"))
            this.closeInventoryDialog()
            this.resetFilters()
        },

        async downloadSmallInventoryPdf() {
            const headerImg = await fetchHeaderImage(this.$axios)
            let filtered = [...this.smallAssets]
            if (this.filters.location) filtered = filtered.filter(a => Number(a.LocationId) === Number(this.filters.location))
            if (this.filters.room) filtered = filtered.filter(a => Number(a.RoomId) === Number(this.filters.room))
            if (!filtered.length) {
                this.$store.dispatch("NOTIF_WARNING", { poruka: this.$t("general.noData"), position: "top-end", timer: 2500 })
                return
            }
            const date = this.smallInventoryForm.reportDate
            if (!date) return
            let tbodyHtml = ""
            filtered.forEach((a, i) => {
                tbodyHtml += `<tr><td class="left">${i + 1}</td><td class="left">${a.Name ?? ""}</td><td class="left">${a.LocationName ?? ""}</td><td class="left">${a.RoomName ?? ""}</td><td class="left">${a.Quantity ?? 1}</td><td class="left"></td></tr>`
            })
            const theadHtml = `<tr><th style="width:6%">${this.$t("table.asset.rbr")}</th><th style="width:28%">${this.$t("table.asset.naziv")}</th><th style="width:18%">${this.$t("modalni.izvjestaji.lokacija")}</th><th style="width:12%">${this.$t("table.asset.soba")}</th><th style="width:8%">${this.$t("general.kolicina")}</th><th style="width:28%; text-align:left !important">${this.$t("modalni.izvjestaji.napomena")}</th></tr>`
            const extraCss = `@page{size:A4 landscape !important;margin:12mm !important;}thead th{background-color:#AFB1B5 !important;color:#ffffff !important;font-weight:700 !important;border:1px solid #949597 !important;-webkit-print-color-adjust:exact;print-color-adjust:exact;}.left{text-align:left !important;}.center{text-align:center !important;}table{margin-top:40px !important;}th{text-align:left !important;}`

            this.html = printTable({
                title: `${this.$t("modalni.izvjestaji.popisnaListaSitniInventar")} ${this.formatDate(date)}`,
                theadHtml, tbodyHtml, extraCss, headerImg,
                footer: `${this.$t("exportToExcel.pokrenuo")} ${localStorage.getItem("Name")} <br />${this.$t("print.m1")} ${format(new Date(), "dd.MM.yyyy.")}`
            })
            this.openReportPreview(this.html, this.$t("modalni.izvjestaji.popisnaListaSitniInventar"))
            this.closeSmallInventoryDialog()
            this.resetFilters()
        }
    },
    watch: {
        reportPreview(val) {
            if (!val) {
                this.isOdlukaPreview = false
                this._odlukaBlob = null
                this._odlukaFileName = null
            }
        },
        inventoryDialog(val) {
            if (!val) { this.rooms = []; this.filters.location = null; this.filters.room = null }
        },
        smallInventoryDialog(val) {
            if (!val) { this.rooms = []; this.filters.location = null; this.filters.room = null }
        },
        statusDialog(val) {
            if (!val) { this.rooms = []; this.filters.location = null; this.filters.room = null }
        }
    }
};
</script>

<style scoped>
.homepage-bg {
    min-height: 100vh;
    background: linear-gradient(to bottom, #f5f8fc 60%, #e3eaf6 100%);
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.homepage-card {
    border-radius: 22px;
    box-shadow: 0 6px 32px 0 rgba(20, 55, 110, 0.07);
    margin-top: 20px;
    margin-bottom: 20px;
}

.hoverable-card {
    transition: box-shadow 0.22s, transform 0.14s;
    cursor: pointer;
    height: 215px;
    border-radius: 10px;
}

.hoverable-card:hover {
    box-shadow: 0 3px 18px 0 #3a86ff24;
    transform: translateY(-3px) scale(1.02);
}

.card-img {
    width: 100%;
    height: 215px;
    object-fit: cover;
    display: block;
}

.report-modal .modal-body {
    padding: 0 !important;
    overflow: hidden;
}

.report-modal iframe {
    width: 100%;
    height: 100%;
}
</style>